import React from 'react';
import moment from 'moment';
import { isBrowser, MobileView, BrowserView } from "react-device-detect";
import { makeStyles, Container, Grid, Paper, Button } from '@material-ui/core';
import FullCalendar from '@fullcalendar/react'
import interactionPlugin from '@fullcalendar/interaction'; // for selectable
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from "@fullcalendar/timegrid";
import LeaveForm from './component/Form'
import EditLeaveApplication from '../MyLeave/component/Edit'
import EditCompLeaveReq from '../MyCompLeaveReqs/component/Edit';
import Guideline from './component/Guideline';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/translucent.css';
import AddOutlined from '@material-ui/icons/AddOutlined';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CircularProgress from '@material-ui/core/CircularProgress';
import customAxios from "../API/customAxios";
import { FormattedMessage, useIntl } from 'react-intl';
import { compareEvents, formatDateTimeHours } from '../Function/globalFunction';

let color = ''
let background = ''
let className = ''

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    subPaper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        fontWeight: 'bolder'
    },
    mainPaper: {
        padding: theme.spacing(1),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        marginBottom: '10px',
    },
    newApplication: {
        backgroundColor: '#2C3E50',
        color: '#fff',
        '&:hover': {
            backgroundColor: '#080C0F',
        }
    },
    generateButton: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginBottom: '10px',
        marginTop: '10px'
    },
    wholeDay: {
        clipPath: 'polygon(0 0, 100% 0%, 100% 100%, 0% 100%)',
        textAlign: 'center'
    },
    am: {
        clipPath: 'polygon(0 0, 50% 0%, 50% 100%, 0% 100%)'
    },
    pm: {
        clipPath: 'polygon(50% 0, 100% 0%, 100% 100%, 50% 100%)',
        textAlign: 'right'
    },
    amToAM: {
        textAlign: 'center'
    },
    amToPM: {
        clipPath: 'polygon(0 0, 100% 0%, 100% 100%, 0% 100%);',
        textAlign: 'center'
    },
    pmToAM: {
        textAlign: 'center'
    },
    pmToPM: {
        textAlign: 'center'
    },
    startToAM: {
        textAlign: 'center'
    },
    endToAM: {
        textAlign: 'center'
    },
    startToPM: {
        textAlign: 'center'
    },
    endToPM: {
        clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
        textAlign: 'center'
    },
    holiday: {
        textAlign: 'center',
        textShadow: '-2px 0 #FFF, 0 2px #FFF, 2px 0 #FFF, 0 -2px #FFF'
    },
    textShadow: {
        textShadow: '-2px 0 #FFF, 0 2px #FFF, 2px 0 #FFF, 0 -2px #FFF'
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
    circularProgressbar: {
        maxWidth: 120
    },
    circularProgress: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(1),
    }
}));

export default function MyCalendar() {
    const classes = useStyles();
    const intl = useIntl();
    const [showCompetent, setShowCompetent] = React.useState(false);
    const [showId, setShowId] = React.useState();
    const [open, setOpen] = React.useState(false);
    const [openForm, setOpenForm] = React.useState(false);
    const [matchList, setMatchList] = React.useState([]);
    const [holidayList, setHolidayList] = React.useState([]);
    const [startDate, setStartDate] = React.useState();
    const [endDate, setEndDate] = React.useState();
    const [startTime, setStartTime] = React.useState();
    const [endTime, setEndTime] = React.useState();
    const [right, setRight] = React.useState();
    const holidayListCalendar = [...holidayList];
    const isShiftDuty = localStorage.getItem('staff_duty') === window.global.shiftDuty;
    const [isNewCompLeave, setIsNewCompLeave] = React.useState(false);
    const [isCompLeaveReq, setIsCompLeaveReq] = React.useState(false);
    const page = isNewCompLeave ? 'Comp Leave Reqs' : 'My Leave';

    React.useEffect(() => {
        let isMounted = true;

        async function fetchData() {
            try {
                let staffDuty = localStorage.getItem('staff_duty');

                if (staffDuty === null) {
                    const userDataResponse = await customAxios.get('/get_user_data');
                    staffDuty = userDataResponse.data.staff_duty || '';
                    if (isMounted) {
                        localStorage.setItem('staff_duty', staffDuty);
                    }
                }

                if (isMounted) {
                    if (staffDuty === window.global.officeHours) {
                        setStartTime("AM");
                        setEndTime("PM");
                    } else if (staffDuty === window.global.shiftDuty) {
                        setStartTime("Section One");
                        setEndTime("Section Two");
                    }
                    setShowCompetent(true);
                }

            } catch (error) {
                console.log('Error fetching user data:', error);
            }
        }
        fetchData();

        return () => {
            isMounted = false;
        };
    }, []);

    React.useEffect(() => {
        customAxios.get('/get_my_leaves').then(res => {
            outputApplication(res.data);
        })

        customAxios.get(`/get_holiday`).then(res => {
            holidayApplication(res.data);
        })

        if (isBrowser) {
            setRight('newLeave prev,next')
        } else {
            setRight('prev,next')
        }
    }, []);

    const getNextDate = (date, day) => {
        var dd = new Date(date);
        dd.setDate(dd.getDate() + day);
        var y = dd.getFullYear();
        var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
        var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
        return y + "-" + m + "-" + d;
    }

    // select
    const select = (selectionInfo) => {
        // Processing Deadline
        selectionInfo.endStr = getNextDate(selectionInfo.endStr, -1)
        setStartDate(selectionInfo.startStr)
        setEndDate(selectionInfo.endStr)
        setOpenForm(true);
    }

    const eventRender = (info) => {
        if (isBrowser === true) {
            var template;
            if (info.event.extendedProps.period === undefined) {
                // Public Holidays
                template = "<div>" + info.event.startStr + "</div>"
            } else {
                // Leave
                template =
                    "<div>" + intl.formatMessage({ id: 'common.from' }) + ": " + info.event.startStr + " " + info.event.extendedProps.mouseOverStartTime + "</div>" +
                    "<div>" + intl.formatMessage({ id: 'common.to' }) + ": " + getNextDate(info.event.endStr, -1) + " " + info.event.extendedProps.mouseOverEndTime + "</div>" +
                    "<div>" + intl.formatMessage({ id: 'new_application.taken' }) + ": " + info.event.extendedProps.period + "</div>"

            }
            tippy(info.el, {
                theme: 'translucent',
                maxWidth: 'none',
                placement: 'bottom',
                content: template,
                allowHTML: true,
            });
        }
    }

    const handleOpen = (info) => {
        if (info.event.extendedProps.resourceId !== undefined) {
            const startTime = info.event.extendedProps.start_time;
            const patterns = window.global.patterns;
            const isContainsPatterns = patterns.some(term => startTime.includes(term));
            const isNewCompLeave = !isContainsPatterns;
            setIsNewCompLeave(isNewCompLeave);

            const isCompLeaveReq = info.event.extendedProps.action == 'Request';
            setIsCompLeaveReq(isCompLeaveReq)

            setShowId(info.event.id)
            setOpen(true);
        }
    }

    const handleClose = () => {
        setOpen(false);
    }

    const handleCloseForm = () => {
        setOpenForm(false);
    }

    const outputApplication = (getData) => {
        let dataForCalendar = [];
        for (var i = 0; i < getData.length; i++) {
            if (String(getData[i].status) !== window.global.withdrawn && String(getData[i].status) !== window.global.cancelled) {
                switch (getData[i].type.name) {
                    case 'Annual Leave':
                        color = '#ffa500'
                        background = ""
                        break;
                    case 'Sick Leave':
                        color = '#00b7eb'
                        background = ""
                        className = ""
                        break;
                    case 'Compensation Leave':
                        color = ('action' in getData[i] && getData[i].action == 'Request') ? '#4DE67F' :'#cccc00'
                        background = ""
                        className = ""
                        break;
                    case 'Maternity Leave':
                        color = '#b8860b'
                        background = ""
                        className = ""
                        break;
                    case 'Paternity Leave':
                        color = '#0000ff'
                        background = ""
                        className = ""
                        break;
                    case 'Marriage Leave':
                        color = '#800080'
                        background = ""
                        className = ""
                        break;
                    case 'Birthday Leave':
                        color = '#ff00ff'
                        background = ""
                        className = ""
                        break;
                    case 'Compassionate Leave':
                        color = '#ccccff'
                        background = ""
                        className = ""
                        break;
                    case 'Examination Leave':
                        color = '#40e0d0'
                        background = ""
                        className = ""
                        break;
                    case 'Jury Leave':
                        color = '#ff7f50'
                        background = ""
                        className = ""
                        break;
                    case 'No Pay Leave':
                        color = '#808000'
                        background = ""
                        className = ""
                        break;
                    case 'Other Leave':
                        color = '#FAEBD7'
                        background = ""
                        className = ""
                        break;
                }

                switch (String(getData[i].status)) {
                    case window.global.pending:
                        background = "repeating-linear-gradient( 45deg, #808080, #808080 4px, " + color + " 4px, " + color + " 10px)"
                        break;
                    case window.global.rejected:
                        color = '#D3D3D3'
                        break;
                    case window.global.submitted:
                        background = "repeating-linear-gradient( 45deg, #808080, #808080 4px, " + color + " 4px, " + color + " 10px)"
                        break;
                    default:
                        background = ""
                        break;
                }

                const graphStartDate = moment(getData[i].start_date).format(window.global.momentFormat);
                const graphUntilDate = moment(getData[i].until_date).format(window.global.momentFormat);

                dataForCalendar.push({
                    id: getData[i].id,
                    resourceId: getData[i].employee_id,
                    employee: getData[i].employee,
                    type: getData[i].type.name,
                    title: formatDateTimeHours(getData[i], 'period', intl),
                    start: graphStartDate,
                    start_time: formatDateTimeHours(getData[i], 'startTime', intl),
                    mouseOverStartTime: formatDateTimeHours(getData[i], 'startTime', intl),
                    end: getNextDate(graphUntilDate, 1),
                    end_time: formatDateTimeHours(getData[i], 'endTime', intl),
                    mouseOverEndTime: formatDateTimeHours(getData[i], 'endTime', intl),
                    period: formatDateTimeHours(getData[i], 'period', intl),
                    color: color,
                    background: background,
                    action: ('action' in getData[i]) ? getData[i].action : '',
                    // Ensure that the css class styles are not in one piece --> + ' ' + 
                    className: className + ' ' + classes.textShadow,
                    textColor: '#000',
                    overlap: true
                })
            }
        }

        dataForCalendar.sort((a, b) => compareEvents(a, b));

        setMatchList(dataForCalendar);
    }

    const holidayApplication = (getData) => {
        let holidayType;
        let holidayName;
        for (var i = 0; i < getData.length; i++) {
            if (localStorage.getItem('locale') === 'en') {
                holidayType = getData[i].name
                holidayName = getData[i].name
            } else if (localStorage.getItem('locale') === 'zh') {
                holidayType = getData[i].name_zh
                holidayName = getData[i].name_zh
            }
            holidayListCalendar.push({
                id: getData[i].id,
                type: holidayType,
                title: holidayName,
                start: getData[i].date,
                start_time: getData[i].date,
                end: getData[i].date,
                end_time: getData[i].date,
                color: '#FEE11D',
                textColor: 'black',
                className: classes.holiday
            })
        }
        setHolidayList(holidayListCalendar);
    }

    const customButtons = {
        newLeave: {
            text: intl.formatMessage({ id: 'leave_application.new_application' }),
            click: function () {
                window.location.href = "/new_application"
            }
        }
    }

    function compLeaveEvent(info) {
        const startDate = moment(info.event.start);
        const endDate = moment(info.event.end);
        const endTime = moment(info.event.extendedProps.end_time, 'HH:mm:ss');
        const startTime = moment(info.event.extendedProps.start_time, 'HH:mm:ss');
        const timeDifference = moment.duration(endTime.diff(startTime)).asHours();
        const modifiedEndDate = endDate.clone().subtract(1, 'days');

        if (info.isStart && info.isEnd) {
            if (startDate.format('YYYY-MM-DD') < modifiedEndDate.format('YYYY-MM-DD')) {
                if (startTime.isBefore(moment('13:00', 'HH:mm')) && endTime.isBefore(moment('13:00', 'HH:mm'))) {
                    info.el.classList.add(classes.amToAM);
                    calculateAMToAM(info);
                } else if (startTime.isAfter(moment('13:00', 'HH:mm')) && endTime.isAfter(moment('13:00', 'HH:mm'))) {
                    info.el.classList.add(classes.pmToPM);
                    calculatePMToPM(info);
                } else if (startTime.isBefore(moment('13:00', 'HH:mm')) && endTime.isAfter(moment('13:00', 'HH:mm'))) {
                    info.el.classList.add(classes.wholeDay);
                } else if (startTime.isAfter(moment('13:00', 'HH:mm')) && endTime.isSameOrBefore(moment('13:00', 'HH:mm'))) {
                    info.el.classList.add(classes.pmToAM);
                    calculatePMToAM(info);
                } else {
                    info.el.classList.add(className = classes.wholeDay);
                }
            } else {
                if (endTime.isSameOrBefore(moment('13:00:00', 'HH:mm:ss')) && timeDifference < 8) {
                    info.el.classList.add(className = classes.amToAM)
                    calculateAMToAM(info);
                } else if (startTime.isSameOrAfter(moment('13:00:00', 'HH:mm:ss')) && timeDifference < 8) {
                    info.el.classList.add(className = classes.pmToPM)
                    calculatePMToPM(info);
                } else if (endTime.isAfter(moment('13:00:00', 'HH:mm:ss')) && timeDifference < 8) {
                    info.el.classList.add(className = classes.pmToPM)
                    calculatePMToPM(info);
                } else if (startTime.isBefore(moment('13:00:00', 'HH:mm:ss')) && timeDifference < 8) {
                    info.el.classList.add(className = classes.amToAM)
                    calculateAMToAM(info);
                } else {
                    info.el.classList.add(className = classes.wholeDay);
                }
            }
        }

        if (info.isStart && !info.isEnd) {
            if (startTime.isAfter(moment('13:00', 'HH:mm'))) {
                info.el.classList.add(classes.startToPM);
                calculateStartToPM(info);
            } else {
                info.el.classList.add(classes.startToAM);
            }
        }

        if (!info.isStart && info.isEnd) {
            if (endTime.isAfter(moment('13:00', 'HH:mm'))) {
                info.el.classList.add(classes.endToPM);
            } else {
                info.el.classList.add(classes.endToAM);
                calculateEndToAM(info);
            }
        }           
    }

    function normalEvent(info) {
        const startTime = info.event.extendedProps.start_time;
        const endTime = info.event.extendedProps.end_time;

        const amTimes = [window.global.am, window.global.sectionOne, window.global.amChinese, window.global.sectionOneChinese];
        const pmTimes = [window.global.pm, window.global.sectionTwo, window.global.pmChinese, window.global.sectionTwoChinese];

        if (info.isStart && info.isEnd) {
            if (amTimes.includes(startTime)) {
                if (amTimes.includes(endTime)) {
                    info.el.classList.add(className = classes.amToAM);
                    calculateAMToAM(info);
                } else {
                    info.el.classList.add(className = classes.amToPM);
                }
            } else if (pmTimes.includes(startTime)) {
                if (amTimes.includes(endTime)) {
                    info.el.classList.add(className = classes.pmToAM);
                    calculatePMToAM(info);
                } else {
                    info.el.classList.add(className = classes.pmToPM);
                    calculatePMToPM(info);
                }
            }
        }

        if (info.isStart && !info.isEnd) {
            if (pmTimes.includes(startTime)) {
                info.el.classList.add(classes.startToPM);
                calculateStartToPM(info);
            } else {
                info.el.classList.add(classes.startToAM);
            }
        }

        if (!info.isStart && info.isEnd) {
            if (pmTimes.includes(endTime)) {
                info.el.classList.add(classes.endToPM);
            } else {
                info.el.classList.add(classes.endToAM);
                calculateEndToAM(info);
            }
        }
    }

    const eventDidMount = (info) => {
        if (info.event.extendedProps.background) {
            info.el.style.background = info.event.extendedProps.background;
        }

        if (info.event.extendedProps.action == 'Leave') {
            compLeaveEvent(info);
        } else {
            normalEvent(info);
        }
    }

    const calculate = (info) => {
        var Difference_In_Time = new Date(info.event.endStr).getTime() - new Date(info.event.startStr).getTime();
        var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
        const day = parseInt(Difference_In_Days);
        return Math.floor(100 / day / 2) + '%';
    }

    const polygonToAM = (adapter) => {
        return 'polygon(0 0, calc(100% - ' + adapter + ') 0, calc(100% - ' + adapter + ') 100%, 0 100%)';
    }

    const polygonToPM = (adapter) => {
        return 'polygon(' + adapter + ' 0, 100% 0, 100% 100%, ' + adapter + ' 100%)';
    }

    const calculateAMToAM = (info) => {
        var adapter = calculate(info);
        textAlignLeft(info, adapter);
        return info.el.style.clipPath = polygonToAM(adapter);
    }

    const calculatePMToAM = (info) => {
        var adapter = calculate(info);
        return info.el.style.clipPath = 'polygon(' + adapter + ' 0, calc(100% - ' + adapter + ') 0, calc(100% - ' + adapter + ') 100%, ' + adapter + ' 100%)';
    }

    const calculatePMToPM = (info) => {
        var adapter = calculate(info);
        textAlignRight(info, adapter);
        return info.el.style.clipPath = polygonToPM(adapter);
    }

    const calculateStartToPM = (info) => {
        var adapter = Math.floor((100 / (7 - info.event.start.getDay()) / 2)) + '%';
        textAlignRight(info, adapter);
        return info.el.style.clipPath = polygonToPM(adapter);
    }

    const calculateEndToAM = (info) => {
        var adapter = Math.floor((100 / (7 - (7 - info.event.end.getDay())) / 2)) + '%';
        textAlignLeft(info, adapter);
        return info.el.style.clipPath = polygonToAM(adapter);
    }

    const textAlignLeft = (info, adapter) => {
        // fc-event-main
        info.el.children[0].style.width = (100 - parseInt(adapter)) + '%';
        info.el.children[0].style.marginRight = adapter;
    }

    const textAlignRight = (info, adapter) => {
        // fc-event-main
        info.el.children[0].style.width = (100 - parseInt(adapter)) + '%';
        info.el.children[0].style.marginLeft = adapter;
    }

    return (
        <main className={classes.content}>
            <div className={classes.appBarSpacer} />
            <Container maxWidth="lg" className={classes.container}>
                <Grid item xs={12} style={{ marginBottom: 8 }}>
                    <Typography
                        component='h1'
                        variant='h5'
                        align='left'
                        style={{ fontWeight: 600 }}
                    >
                        {intl.formatMessage({id: 'navigation.application'}) + ' - ' + intl.formatMessage({id: 'navigation.leave'})}
                    </Typography>
                </Grid>
                <BrowserView>
                    <Grid item xs={12}>
                        <Paper className={classes.mainPaper}>
                            <Guideline page={'Calendar'} />
                        </Paper>
                    </Grid>
                </BrowserView>
                <MobileView>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography className={classes.heading}>{intl.formatMessage({ id: 'guideline' })}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Guideline page={'Calendar'} />
                        </AccordionDetails>
                    </Accordion>
                </MobileView>
                <MobileView>
                    <Grid item xs={12}>
                        <div className={classes.generateButton}>
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                className={classes.newApplication}
                                startIcon={<AddOutlined />}
                                href="/new_application"
                            >
                                {intl.formatMessage({ id: 'leave_application.new_application' })}
                            </Button>
                        </div>
                    </Grid>
                </MobileView>
                {showCompetent ?
                    <Paper className={classes.subPaper}>
                        <FullCalendar
                            timeZone='Asia/Hong_Kong'
                            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                            initialView="dayGridMonth"
                            selectable="true"
                            eventMouseEnter={eventRender}
                            headerToolbar={{
                                left: '',
                                center: 'title',
                                right: right
                            }}
                            customButtons={customButtons}
                            contentHeight={600}
                            select={select}
                            eventSources={[matchList, holidayListCalendar]}
                            eventClick={handleOpen}
                            eventDurationEditable="true"
                            eventDidMount={eventDidMount}
                            selectLongPressDelay={100}
                            eventOrder="start"
                        />
                    </Paper>
                    :
                    <div className={classes.circularProgress}>
                        <CircularProgress />
                    </div>
                }
            </Container>
            {open && 
                (isCompLeaveReq ? (
                    <EditCompLeaveReq
                        handleClose={handleClose}
                        open={open}
                        showId={showId}
                        actionPage='Comp Leave Reqs'
                    />
                ) : (
                    <EditLeaveApplication 
                        handleClose={handleClose} 
                        open={open} 
                        showId={showId} 
                        type={page} 
                        isNewCompLeave={isNewCompLeave}
                    />
                ))}
            {openForm && 
                <LeaveForm 
                    handleClose={handleCloseForm} 
                    open={openForm} 
                    startDate={startDate} 
                    endDate={endDate} 
                    startTime={startTime} 
                    endTime={endTime}
                />
            }
        </main>
    );

}